import { PageHeading, TeamHeading } from "@/components/Layout/Parts";
import ExtractorForm from "./components/ExtractorForm";
import ExtractorRecentResults from "./components/ExtractorRecentResults";

const PngExtractor = () => {
  return (
    <>
      <TeamHeading />
      <PageHeading>PNG Extractor</PageHeading>
      <ExtractorForm />
      <ExtractorRecentResults />
    </>
  );
};

export default PngExtractor;
